import ConstructionIcon from '@mui/icons-material/Construction';
import { Box, Typography } from '@mui/material';
import themev5 from 'src/themev5';

interface ComingSoonProps {
  message?: string;
  iconSize?: 'small' | 'medium' | 'large';
}

const iconSizes = {
  small: { fontSize: 48, spacing: 2 },
  medium: { fontSize: 64, spacing: 3 },
  large: { fontSize: 96, spacing: 4 },
};

export function ComingSoon({ message, iconSize = 'medium' }: ComingSoonProps) {
  const { fontSize, spacing } = iconSizes[iconSize];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        minHeight: { xs: '200px', sm: '300px', md: '400px' },
        p: { xs: 2, sm: 3, md: 4 },
        gap: spacing,
        textAlign: 'center',
      }}>
      <ConstructionIcon
        sx={{
          fontSize: { xs: fontSize * 0.75, sm: fontSize },
          color: 'primary.main',
        }}
      />
      <Typography
        variant="h6"
        fontWeight={themev5.typography.fontWeightBold}
        color="text.primary"
        sx={{
          fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
          maxWidth: '600px',
        }}>
        Em breve!
        <Typography component="p" sx={{ mt: 1 }}>
          {message ?? 'Fique ligado para as novidades da plataforma'}
        </Typography>
      </Typography>
    </Box>
  );
}
